import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/Nursery/GeneralAwareness";
import { Helmet } from "react-helmet";

const GeneralAwareness: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - Nursery - General Awareness"; // Set page title
    }, []);

    return (
        <>
            <Helmet>
                <meta name="description" content='Build essential knowledge with general awareness activities for nursery kids on Mamas Guidance—featuring engaging topics like colors, shapes, seasons, community helpers, and more to spark curiosity and understanding of the world.' />
            </Helmet>
            <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
        </>
    );
};
export default GeneralAwareness;